import React from 'react';
import Header from '../components/header/Header';
import Speakings from '../components/speakings/Speakings';
import Footer from '../components/footer/Footer';
import ScrollUp from '../components/scrollup/ScrollUp';
import About from '../components/about/About';

const PublicS = () => {
    return (
        <>
            <Header />
            <Speakings/>
            <Footer />
            <ScrollUp />
        </>
    )
}

export default PublicS;